// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes rotate-b6414906{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.rotate-image[data-v-b6414906]{animation:rotate-b6414906 8s linear infinite;transform-origin:center}.letter[data-v-b6414906]{letter-spacing:.1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
